/**
 * Development-only logger utility
 * Production에서는 console 출력을 방지합니다
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: unknown[]): void => {
    if (isDevelopment) {
    }
  },

  warn: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  error: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.error(...args);
    }
  },

  debug: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  info: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  // Production에서도 중요한 에러는 출력 (운영 모니터링용)
  critical: (...args: unknown[]): void => {
    console.error('[CRITICAL]', ...args);
  },
};

export default logger;
